import { useEffect, useState } from 'react';
import webpSupported from './isWebpSupported';
import { hasWebpVersion, getWebpUrl, getFallbackUrl } from './webpUtils';
import { FeatureFlags, getFeatureFlag } from '../../utilities/featureFlags';

export default function useWebpFile(src) {
    const enableWebp = getFeatureFlag(FeatureFlags.PREFER_WEBP_IMAGES);
    const [isWebpSupported, setIsWebpSupported] = useState(enableWebp);
    const [parsedSrc, setParsedSrc] = useState(() => {
        return enableWebp ? getWebpUrl(src) : getFallbackUrl(src)
    });

    useEffect(() => {
        if (enableWebp) {
            webpSupported
                .then(supported => setIsWebpSupported(supported))
                .catch(() => setIsWebpSupported(false));
        } else {
            console.warn(`useWebpFile: WEBP format is disabled for ${src}`);
        }
    }, []);

    useEffect(() => {
        setParsedSrc((isWebpSupported && hasWebpVersion(src)) ? getWebpUrl(src) : getFallbackUrl(src));
    }, [isWebpSupported]);

    return parsedSrc;
}